<div class="row mb-2">
  <form class="ngForm row row-cols-auto" [formGroup]="form">
    <div class="col-auto g-2">
      <div
        class="input-wrapper"
        (click)="openDatePicker($event)"
        (keydown.enter)="openDatePicker($event)">
        <input
          type="text"
          ngxDaterangepickerBootstrap
          [timePicker]="showTime"
          [timePicker24Hour]="true"
          [timePickerSeconds]="true"
          [locale]="locale"
          [ranges]="ranges"
          [alwaysShowCalendars]="true"
          [linkedCalendars]="false"
          [autoApply]="false"
          [(ngModel)]="selected"
          [ngModelOptions]="{standalone: true}"
          (datesUpdated)="choosedDate($event)"
          (rangeClicked)="rangeClicked($event)"
          (keydown)="onInputKeydown($event)"
          class="form-control form-control-sm"
          placeholder="Select date range" />
        <div class="icon">
          <i class="fa fa-calendar"> </i>
        </div>
      </div>
    </div>
  </form>
</div>
